<template>
   	<router-view/>
</template>

<script>
export default {
	created(){
		this.$router.push({name:'MenuPrincipal'});
	}
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue